import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import "./App.css";
import { Toaster } from './components/ui/sonner';

// Components
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ChallengesSection from './components/ChallengesSection';
import SolutionsSection from './components/SolutionsSection';
import ComparisonSection from './components/ComparisonSection';
import TrustSection from './components/TrustSection';
import PricingSection from './components/PricingSection';
import UsageSection from './components/UsageSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import ContactModal from './components/ContactModal';

// Landing Page Component
const LandingPage = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const openContactModal = () => setIsContactModalOpen(true);
  const closeContactModal = () => setIsContactModalOpen(false);

  return (
    <div className="min-h-screen bg-slate-950">
      <Header onContactClick={openContactModal} />
      <main>
        <HeroSection onContactClick={openContactModal} />
        <ChallengesSection />
        <SolutionsSection />
        <ComparisonSection />
        <TrustSection />
        <PricingSection onContactClick={openContactModal} />
        <UsageSection />
        <FAQSection />
        <CTASection onContactClick={openContactModal} />
      </main>
      <Footer />
      <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;